module.exports = __webpack_public_path__ + "img/avatar.0d855cb8.png";